module.exports = require("./kk-KZ.js");